import 'swiper/css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { imageSliderConfig } from '../pages/hotel-detail';

export function ActivityCarousel({ slides }) {
  if (!slides?.length) {
    return null;
  }

  return (
    <Swiper
      loop
      className="!rounded-none !m-0"
      {...imageSliderConfig}
      autoplay={{ delay: 5000 }}
    >
      {slides.map((slide, index) => (
        <SwiperSlide key={index}>
          <div className="overflow-hidden h-[250px] sm:h-[400px] w-full">
            <img
              src={slide}
              className="h-full w-full object-cover"
              alt={`Slide ${index}`}
            />
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
